export default __webpack_public_path__ + "d8ddb66daf06c73dc56043996a5aaa4f.jpg";